<template>
  <div class="content">
    <!--<van-nav-bar class="invest-title" :fixed="true" title="我的众筹"/>
    <img class="invest-reback" src="../../assets/myInvest/reback.png">-->
    <div class="all">
      <van-tabs sticky scroll="{ scrollTop: 64, isFixed: true }">
        <van-tab title="全部">
          <allOrder orderStyle="0" />
        </van-tab>
        <van-tab title="待付款">
          <allOrder orderStyle="10" />
        </van-tab>
        <van-tab title="正参与">
          <allOrder orderStyle="20" />
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>
<script>
import allOrder from "./allOrder.vue";
export default {
  components: {
    allOrder,
  },
};
</script>
<style scoped>
.content {
  background-color: #f2f2f2;
  height: 100%;
}
.content >>> [class*="van-hairline"]::after {
  border: none;
}

.all {
  padding-top: 69px;
  height: 100%;
  box-sizing: border-box;
  background-color: #f2f2f2;
}
.isiOSX .all {
  padding-top: 89px;
}
.all .van-tabs {
  min-height: 100%;
}
.all >>> .van-tabs__line {
  background-color: #1d1e1f;
  height: 2px;
}
.all >>> .van-tab {
  font-size: 16px;
  color: #999999;
  font-weight: 400;
}
.all >>> .van-tab--active {
  color: #1d1e1f;
  font-size: 16px;
  font-weight: 600;
}
.all >>> .van-sticky {
  position: fixed;
  top: 64px;
  width: 100%;
  z-index: 2;
}
.isiOSX .all >>> .van-sticky {
  top: 84px;
}
</style>


